import React, { useContext, useEffect, useState } from 'react';
import StudentNavbar from '../StudentNavbar/StudentNavbar';
import Sidebar from '../StudentSidebar/Sidebar';
import Image from '../../Components/Reusable/Image';
import { PngImages, SvgImages } from '../../Utils/LocalImages';
import { Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import RoutesPath from '../../Utils/RoutesPath';
import { AuthContext } from '../../Context/authContext';
import StudentDashboardServices from '../../Services/StudentDashboardApiService';
import ApiConstants from '../../Utils/ApiConstant';
import SubmitButtonTwo from '../../Components/Reusable/Buttontwo';
import { toast } from 'react-toastify';
import { CirclesWithBar } from 'react-loader-spinner';
import { yupResolver } from '@hookform/resolvers/yup';
import { handleApiErrors, InputType, validationRegex } from '../../Utils/Utils';
import * as yup from "yup";
import { useForm } from 'react-hook-form';
import CustomTextFieldTwo from '../../Components/Reusable/CustomTextFieldTwo';

let cartCount = ""
const AddToCartPage = () => {
    const { user, updateUserCartCount } = useContext(AuthContext);
    const [cartData, setCartData] = useState([]);
    const [cartSummary, setCartSummary] = useState({});
    const [loading, setLoading] = useState(true);
    const [refferalcode, setRefferalCode] = useState({});
    const [couponCode, setCouponCode] = useState({});
    const navigate = useNavigate()
    const Validations = yup.object().shape({
        // referralcode: validationRegex.required,
    });

    const {
        register,
        handleSubmit,
        setValue: setValues,
        formState: { errors },
        getValues,
        reset,
    } = useForm({
        resolver: yupResolver(Validations),
        defaultValues: {
            referralcode: "",
        },
    });

    const getAllCart = async () => {
        setLoading(true);
        try {
            const response = await StudentDashboardServices.getAllCart();
            setCartData(response.cartList || []);
            setCartSummary(response.summary || {});
            cartCount = response.cartCount
            updateUserCartCount(cartCount);


        } catch (error) {
            handleApiErrors(error);
        } finally {
            setLoading(false);
        }
    };
    const deleteCart = async (cart_id) => {
        try {
            const response = await StudentDashboardServices.deleteCart(cart_id);
            toast.success("Cart Delete Successfully!")
            getAllCart()
        } catch (error) {
            handleApiErrors(error);
        }
    };

    const ApplyRefferal = async () => {
        const referralcode = getValues('referralcode');
        if (!referralcode) {
            toast.error("Please Enter Discount/Referral Code");
            return;
        }
        try {
            const response = await StudentDashboardServices.checkReferralCode(referralcode);
            if (response.status === 200) {
                setRefferalCode(response.data.coordinator || "");
                setCouponCode(response.data.couponCode || "");
                toast.success("Discount/Referral Code Applied");
                reset();
            } else {
                setRefferalCode({})
                setCouponCode({})
                reset();
            }
        } catch (error) {
            handleApiErrors(error);
            setRefferalCode({})
            setCouponCode({})

        }
    }

    useEffect(() => {
        getAllCart();
    }, [cartCount]);


    return (

        <div className="d-flex">
            <Sidebar />
            <div className="mainLayout-content">
                <StudentNavbar />
                <div className="main_content contentSection scroll_bar">
                    <div className="mb-4 d-flex justify-content-between align-items-center">
                        <h1 className="black sub-large-text-one fw-700 mb-0">Cart</h1>
                        <Link to={RoutesPath.dashboardstudent}>
                            <div className="d-flex" style={{ paddingRight: "10px" }}>
                                <h4 className="Caption fw-600  mb-0"><span className='orangeAccentColor'>Back</span> &gt;</h4>
                            </div>
                        </Link>
                    </div>
                    {loading ? (
                        <div className="text-center d-flex justify-content-center">
                            <CirclesWithBar
                                height="80"
                                width="80"
                                color="#F6821F"
                                ariaLabel="bars-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                            />
                        </div>
                    ) : (
                        <>
                            {
                                cartData.length === 0 ?
                                    <div className="no-records-container text-center" >
                                        <div className="no-record-image " >
                                            <Image src={PngImages.no_record} className="img-fluid" />
                                        </div>
                                        <p className="no-records-text sub-large-text-one fw-700 mb-4">No records found</p>

                                    </div> :
                                    <div className="my-3 row">
                                        <div className='col-xxl-9 col-lg-7 col-md-12 col-sm-12 '>

                                            {cartData.map(item => (

                                                < div key={item.cart_id} className="cart-item row me-3 py-4 hrline2 respo-item" >
                                                    <div className='col-lg-3 col-md-6 col-sm-6 col-xs-6 addtocardimagesizecart pb-2'>
                                                        <Image className="card-img-top addtocartimage " src={item?.mainImage && item.mainImage?.trim() !== "" ? ApiConstants.FILE_FETCH_URL + item.mainImage : ""} />

                                                    </div>
                                                    <div className='col-lg-9 col-md-6 col-sm-6 col-xs-6 justify-content-between d-flex  text-start respo-cont '>
                                                        <div className='  col-lg-10 col-md-10 col-sm-10 col-xs-10   py-2 '>
                                                            <div className='medium-text fw-700 text-dark py-2'>{item.packageName}</div>
                                                            {/* <p>Price: ₹{item.price}</p> */}
                                                            <div className="d-flex gap-2">
                                                                <span className="disprice sub-large-text  fw-700">₹{item.discountedPrice}</span>
                                                                <div className="originalprice small-text fw-400 pb-1">₹{item.actualPrice}</div>
                                                            </div>
                                                        </div>
                                                        <div className=' col-lg-2 col-md-2 col-sm-2 col-xs-2 py-2  delete_icons cursor-pointer' onClick={() => deleteCart(item.cart_id)}>
                                                            <Image src={PngImages.Group} alt="Delete Icon" className="" />
                                                        </div>

                                                    </div>
                                                </div>
                                            ))}
                                            <div className="row my-4 d-flex align-items-center">
                                                <div className='small-medium-text fw-700 py-2'>Discount/Referral Code</div>
                                                <div className="col-md-8 text-muted">
                                                    <CustomTextFieldTwo
                                                        // labelTitle=""
                                                        placeholder="Enter referral code"
                                                        name="referralcode"
                                                        additionalClasses="profile_edit"
                                                        id="referralcode"
                                                        labelClass="TextInput"
                                                        inputType={InputType.text}
                                                        // showMandatory={true}
                                                        register={register}
                                                        setValue={setValues}
                                                        showError={errors?.referralcode}
                                                        errorMessage={errors?.referralcode?.message}
                                                    />
                                                </div>
                                                <div className="col-md-4 small-text fw-500 pb-2">
                                                    <Button className=" justify-content-center text-center border-0 w-50 py-2" variant="primary" style={{ backgroundColor: '#14489F' }}
                                                        onClick={() => ApplyRefferal({})}
                                                    >Apply</Button>
                                                </div>
                                            </div>
                                        </div>



                                        <div className='col-xxl-3 col-lg-5 col-md-12 col-sm-12  mt-4 '>
                                            <div className='p-5 align-items-center align-self-top' style={{ backgroundColor: '#f3f5f6', borderRadius: "20px" }}>
                                                <p className='sub-large-text fw-700' style={{ color: '#14489F' }} >Summary</p>
                                                <div className='hrline2 text-dark'>
                                                    <div className='justify-content-between d-flex py-3 small-medium-text fw-500 '>
                                                        <div className=''>Subtotal:</div>
                                                        <div className='fw-500'>₹{cartSummary.subTotal}</div>
                                                    </div>
                                                    {refferalcode.referralCode && <div className='justify-content-between d-flex  py-3 small-medium-text fw-500'>
                                                        <div className=''>Discount:</div>
                                                        <div className='text-success fw-500'>-₹ {cartSummary.discountAmt}</div>
                                                    </div>}
                                                    {couponCode.discountAmount && <div className='justify-content-between d-flex  py-3 small-medium-text fw-500'>
                                                        <div className=''>Discount:</div>
                                                        <div className='text-success fw-500'>-₹ {couponCode.discountAmount}</div>
                                                    </div>
                                                    }
                                                </div>
                                                {!couponCode.discountAmount && <div className='justify-content-between d-flex fw-600 small-medium-text py-3 mb-5'>
                                                    <div className=''>Total Amount:</div>
                                                    <div className=''>₹{refferalcode.referralCode ? cartSummary.grandTotalCoordinator : cartSummary.grandTotal}</div>
                                                </div>}
                                                {couponCode.discountAmount && <div className='justify-content-between d-flex fw-600 small-medium-text py-3 mb-5'>
                                                    <div className=''>Total Amount:</div>
                                                    <div className=''>₹{couponCode.grandTotal}</div>
                                                </div>}

                                                <div className='pt-3 checkoutbtn'>
                                                    {/* <Link to={RoutesPath.checkout}> */}
                                                    <Button className="addtocardbtn Blogtexting Sub-Heading fw-600 w-100 justify-content-center text-center border-0 py-2" onClick={() => {console.log(refferalcode,couponCode);navigate(RoutesPath.checkout, { state: {refferalcode,couponCode} })}} style={{ borderRadius: "10px", backgroundColor: "#F6821F" }}>
                                                        Proceed to Checkout
                                                    </Button>
                                                    {/* </Link> */}

                                                </div>
                                            </div>



                                        </div>

                                    </div>
                            }
                        </>)}

                    <Link to={RoutesPath.dashboardstudent}>
                        <span className='orangeAccentColor align-items-center small-text fw-500 mt-4 '>{'<'}&nbsp; Add More Packages</span>
                    </Link>
                </div>
            </div>
        </div >
    );
};

export default AddToCartPage;

